// -----------------------------------------------------------------------------
// Cookie-Hinweis
// -----------------------------------------------------------------------------

window.klaro = klaro; // eslint-disable-line no-undef

const init = () => {
  addOpenEventListener();
};

/**
 * Cookie-Hinweis öffnen, um Einstellungen zu ändern
 */
const addOpenEventListener = () => {
  $('.js-klaro-settings').on('click', (e) => {
    e.preventDefault();
    klaro.show(); // eslint-disable-line no-undef
  });
};

export {
  init
};
